export function getKidNameById({kids, id, fallback = '-'}) {
  return kids?.find((kid) => kid.id === id)?.name || fallback;
}
